import { ICommandBarItemProps } from "@fluentui/react";
import { RouterParams } from "App";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { EViewType } from "global/Application";
import { BuildVisibilityScope } from "global/Visibility/GlobalVisibility";
import { useEffect, useMemo, useState } from "react";
import { connect, ConnectedProps } from 'react-redux';
import { useParams } from "react-router-dom";
import AccountsReceivableProperties from "./AccountsReceivableProperties";
import GroupConfigurationSnapshotContext from "./GroupConfigurationSnapshotContext";
import FeesAndPremiumView from "./FeesAndPremium/FeesAndPremiumView";
import FlexibleFieldView, { EScopeType } from "./FlexibleFieldView";
import GroupStructureGroupNumberView from "./GroupStructureGroupNumberView";
import NonStandardApplyTemplate from "./NonStandardApplyTemplate";

interface IAccountsReceivableProps extends TComponentConnectedProps {
}

const AccountsReceivable = (props: IAccountsReceivableProps) => {
    const disabled = props.state.status.viewType !== EViewType.Modify;

    const params = useParams<RouterParams>();
    const [propertiesIsOpen, setPropertiesIsOpen] = useState(false);

    const [applyTemplateIsMounted, setApplyTemplateIsMounted] = useState(false);
    const [applyTemplateIsOpen, _setApplyTemplateIsOpen] = useState(false);
    const setApplyTemplateIsOpen: React.Dispatch<React.SetStateAction<boolean>> = (value) => {
        if (!applyTemplateIsMounted)
            setApplyTemplateIsMounted(true);
        _setApplyTemplateIsOpen(value);
    }

    useEffect(() => {
        document.title = `Accounts Receivable`;

        if (accountsReceivable?.name)
            document.title = `Accounts Receivable | ${accountsReceivable?.name}`;
    }, []);


    const contextMenu = useMemo(() => {
        const items: ICommandBarItemProps[] = []

        if (!disabled)
            items.push({
                key: 'plan',
                text: 'Properties',
                iconProps: { iconName: 'Settings' },
                onClick: () => setPropertiesIsOpen(true)
            });

            items.push({
                key: 'groupConfiguration.nonStandardTemplate.add',
                name: 'Apply Non-Standard Template',
                iconProps: { iconName: 'Generate' },
                onClick: (event, item) => {
                    setApplyTemplateIsOpen(true);
                },
            },);

        return { items: items, key: 'stopLoss' };
    }, []);


    const accountsReceivable = props.state?.data.json?.claimsARs?.find(q => q.id === params.claimsARId);
    const categoryAccountsReceivable = props.state.data.config.cache?.map_bcbs_config_category_named["Accounts Receivable"];

    const controlVisibility = BuildVisibilityScope(
        null,
        props.state.data.json,
        null,
        null
    );


    const feesAndPremiums = props.state?.data.json?.feesAndPremiums?.filter(q => q.id === '')!;

    const onRenderApplyTemplate = () => {
            if (!applyTemplateIsMounted)
                return <></>
    
            return <>
                <NonStandardApplyTemplate
                    isOpen={applyTemplateIsOpen}
                    onDismiss={() => { setApplyTemplateIsOpen(false); setApplyTemplateIsMounted(false) }}
                    accountsReceivable={accountsReceivable}
                    isNewNSAndChooseTemplate={false}
                />
            </>;
        }

    return (
        <GroupConfigurationSnapshotContext contextMenu={contextMenu}>
            {accountsReceivable &&
                <>
                    {onRenderApplyTemplate()}
                    <AccountsReceivableProperties
                        isOpen={propertiesIsOpen}
                        onDismiss={() => setPropertiesIsOpen(false)}
                        data={{ accountsReceivable: accountsReceivable }}
                    />
                    <CustomPanel title={"Attributes"}
                        canCollapse={true}
                        defaultCollapsed={false}
                        storageId="accountsReceivable.Attributes"
                    >
                        <FlexibleFieldView
                            disabled={props.state.status.viewType === EViewType.ViewOnly}
                            fields={accountsReceivable.fields}
                            category={categoryAccountsReceivable}
                            tiers={[]}
                            scope={accountsReceivable}
                            visibility={controlVisibility}
                            scopeType={EScopeType.accountsReceivable}
                        />
                    </CustomPanel>

                    <GroupStructureGroupNumberView
                        currentAR={accountsReceivable}
                        disabled={disabled}
                    />


                    {feesAndPremiums && feesAndPremiums.map((eachFeesAndPremium) => {
                        return (
                            <CustomPanel
                                id={`feesAndPremiums.${eachFeesAndPremium.id}`}
                                title={`Related - ${eachFeesAndPremium.name}`}
                                canCollapse={true}
                                defaultCollapsed={true}
                                mountWhenExpanded={true}
                            >
                                <FeesAndPremiumView
                                    disabled={true}
                                    feesAndPremium={eachFeesAndPremium}
                                    visibility={controlVisibility}
                                />
                            </CustomPanel>
                        );
                    })}

                </>
            }
        </GroupConfigurationSnapshotContext>
    )
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(AccountsReceivable)